<template>
  <div v-if="drawer">
    <v-navigation-drawer
    app
    class="navigation_drawer"
    :mini-variant="miniState"
    absolute
    :width="180"
    permanent
    :temporary="$vuetify.breakpoint.smAndDown"
    :value="drawer"
    @input="$emit('update:drawer', $event)"
    >

      <div class="drawer_list">
        <div :class="{ 'is-mini': miniState }" class="drawer-content">
          <v-list class="pa-0">
            <v-list-item-group v-model="selectedItem">
              <v-list-item
                v-for="(item, index) in items"
                :key="index"
                @click="selectItem(item)"
                :value="item"
                :to="item.to"
              >
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-list-item-icon v-on="on">
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                  </template>
                  <span>{{ $store.getters.t(item.title) }}</span>
                </v-tooltip>
                <v-list-item-content v-show="!mini" permanent>
                  <v-list-item-title v-text="$store.getters.t(item.title)"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
        <div :class="['version', { mini: miniState }]">
          <span class="version-label">Version</span>
          <span class="version-number">{{ Version }}</span>
        </div>
      </div>
    </v-navigation-drawer>

    <v-navigation-drawer
      :width="200"
      app
      class="group_list_drawer"
      v-if="groupListDrawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      absolute
      permanent
      :temporary="$vuetify.breakpoint.smAndDown"
      >
      <GroupList :mini="miniState" :view-type="currentViewType" @close-drawer="drawer = false"/>
    </v-navigation-drawer>

    <v-navigation-drawer
      :value="drawer"
      @input="$emit('update:drawer', $event)"
      :width="180" app class="sub_menu_drawer"
      v-if="subMenuDrawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      absolute
      >
      <SubMenu :selected-item="selectedItem" class="submenu" @mini="handleMiniModeChange"/>
    </v-navigation-drawer>
  </div>
</template>

<script>
import GroupList from './TheGroupList.vue';
import SubMenu from './TheSubMenu.vue';

export default {
  name: 'TheDrawer',
  components: {
    GroupList,
    SubMenu,
  },
  props: {
    drawer: Boolean,
    //items: Array,
  },
  data() {
    return {
      //drawer: true,
      miniState: false,
      selectedItem: null,
      mini: false,
      subMenuDrawer: false,
      groupListDrawer: false,
      localDrawer: this.drawer,
      flag: false,
      temp: [],
      current: null,
      alllist: 'All Groups',
      // Version: 'v1_1'
      Version: '',
    };
  },
  methods: {
    handleMiniModeChange(miniStatus) {
      this.$set(this, 'mini', miniStatus);
    },
    selectItem22(item) {
      const isSameItem = this.selectedItem === item;
      this.flag = !this.flag;

      if (!isSameItem) {
        this.selectedItem = item;
      }

      if (item.to === '/playlist' || item.to === '/asset') {
        this.groupListDrawer = true;
        this.subMenuDrawer = false;
        this.miniState = true;
      }
      else if (item.children && item.children.length > 0) {
        this.groupListDrawer = false;
        this.subMenuDrawer = true;
        this.miniState = true;

        if (!isSameItem) {
          this.navigateToFirstChild(item);
        }
      }
      else {
        this.groupListDrawer = false;
        this.subMenuDrawer = false;
        this.miniState = false;

        if (item.to && this.$route.path !== item.to) {
          this.$router.push(item.to).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              console.error('Navigation Error:', err);
            }
          });
        }
      }
    },

    selectItem(item, options = {}) {
      const skipChildNavigation = options.skipChildNavigation === true;
      if (this.selectedItem === item) {
        this.flag = !this.flag;
        if(this.flag){
          
        }
        else {

        }
      }
      else {
        this.flag = false;
        this.$set(this, 'selectedItem', item);
        // console.log("item.to => ", item)
       
        if (item.to === '/playlist' || item.to === '/asset') {
          this.groupListDrawer = true;
          this.subMenuDrawer = false;

        }
        else if (item.children && item.children.length > 0) {
          this.groupListDrawer = false;
          this.subMenuDrawer = true;
          if (!skipChildNavigation) {
            const currentPath = this.$route.path;
            if (!this.hasRouteInChildren(item, currentPath)) {
              this.navigateToFirstChild(item);
            }
          }
        }
        else {
          this.groupListDrawer = false;
          this.subMenuDrawer = false;
          this.navigateToItem(item);

          if (item.to && this.$route.path !== item.to) {
            this.$router.push(item.to).catch(err => {
              if (err.name !== 'NavigationDuplicated') {
                throw err;
              }
            });
          }
        }
      }
    },
    navigateToFirstChild(item) {
      let route = this.findFirstRoute(item);
      if (route && this.$route.path !== route) {
        this.$router.push(route).then(() => {
          this.subMenuDrawer = true;
          this.groupListDrawer = false;
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation Error:', err);
          }
        });
      } else {
        this.subMenuDrawer = false;
        this.groupListDrawer = false;
        this.miniState = false;
      }
    },
    findFirstRoute(item) {
      if (item.to) {
        return item.to;
      }
      if (item.children && item.children.length > 0) {
        return this.findFirstRoute(item.children[0]);
      }
      return null;
    },
    hasRouteInChildren(item, path) {
      if (!item || !path) {
        return false;
      }
      if (item.children && item.children.length > 0) {
        for (const child of item.children) {
          if (child.to === path) {
            return true;
          }
          if (child.children && child.children.length > 0 && this.hasRouteInChildren(child, path)) {
            return true;
          }
        }
      }
      return false;
    },
    navigateToItem(item) {
      if (item.to) {
        this.$router.push(item.to).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation Error:', err);
          }
        });
      } else {
        this.subMenuDrawer = false;
        this.groupListDrawer = false;
        this.miniState = false;
      }
    },
    updateDrawerState() {
      if (!this.items || this.items.length === 0) {
        return;
      }
      const path = this.$route.path;

      const specialRoutes = ['/playlist', '/asset'];
      // console.log('확인', matchedItem);
      const matchedItem = this.items.find(item => item.to === path) ||
        this.items.find(item =>
          item.children?.some(child =>
            child.to === path || child.children?.some(grandchild => grandchild.to === path)
          )
        );
      // console.log('matchedItem', matchedItem);
      if (matchedItem) {
        const hasChildren = Array.isArray(matchedItem.children) && matchedItem.children.length > 0;
        this.miniState = specialRoutes.includes(path) || hasChildren;
        this.selectItem(matchedItem, { skipChildNavigation: true });
      }
    },
    handleRoute(to, from){
        if (from && from.path) {
          // if(to.path === '/asset-modify'){
          //   this.current = 'asset-modify';

          //   this.groupListDrawer = true;
          //   this.subMenuDrawer = false;

          //   this.miniState = true;
          // } else if(to.path === '/asset'){

          //   this.groupListDrawer = true;
          //   this.subMenuDrawer = false;
            
          //   this.miniState = true;
          // }

          // else if(from.path === '/playlist' && to.path === '/asset'){
          //   this.$store.dispatch('group/updateSelectedGroupId', 'all');
          //   this.$store.dispatch('group/updateSelectedGroupName', 'All Groups');
          // } 

          // else if(from.path === '/asset-modify' && to.path === '/asset'){
          //   this.current = null;
          //   this.updateDrawerState();
          // } 
          // else if(from.path === '/asset-modify' && to.path === '/playlist'){
          //   this.current = null;
          //   this.updateDrawerState();
          // }
          // else if(to.path != from.path){
          //   this.$store.dispatch('asset/updateFlag', false);
          //   this.$store.dispatch('group/updateSelectedGroupId', 'all');
          //   this.$store.dispatch('group/updateSelectedGroupName', 'All Groups');

          //   this.updateDrawerState();
          // }
          

          if (to.path === '/asset-modify') {
              this.current = 'asset-modify';

              this.groupListDrawer = true;
              this.subMenuDrawer = false;

              this.miniState = true;
          } else if (to.path === '/asset') {
              this.groupListDrawer = true;
              this.subMenuDrawer = false;
              
              this.miniState = true;
          } 

          if ((from.path === '/playlist' && to.path === '/asset') || (from.path === '/asset' && to.path === '/playlist')) {
                this.$store.dispatch('group/updateSelectedGroupId', 'all');
                this.$store.dispatch('group/updateSelectedGroupName', this.alllist);
          }

          // if ((from.path === '/playlist' && to.path === '/asset')) {
          //     this.$store.dispatch('group/updateSelectedGroupId', 'all');
          //     // this.$store.dispatch('group/updateSelectedGroupName', 'VOD 관리 > All Groups');
          //     // this.$store.dispatch('group/updateSelectedGroupName', 'All Groups');
          //     this.$store.dispatch('group/updateSelectedGroupName', 'VOD 관리 > All Groups');
          // } 

          // if ((from.path === '/asset' && to.path === '/playlist')) {
          //     this.$store.dispatch('group/updateSelectedGroupId', 'all');
          //     this.$store.dispatch('group/updateSelectedGroupName', '플레이리스트 > All Groups');
          // } 

          if ((from.path === '/playlist' && to.path !== '/asset') || from.path === '/asset' && to.path !== '/playlist') {
              this.$store.dispatch('group/updateSelectedGroupId', 'all');
              // this.$store.dispatch('group/updateSelectedGroupName', '플레이리스트 > All Groups');
              this.$store.dispatch('group/updateSelectedGroupName', this.alllist);
              // this.updateAllGroupsName();

              this.updateDrawerState();
          } 

          const data = this.$store.state.asset.watchFlag;

          if (from.path === '/asset-modify' && to.path === '/asset') {
              this.current = null;
              this.updateDrawerState();

              // if(!data){
              //   this.$store.dispatch('group/updateSelectedGroupName', 'VOD 관리 > All Groups');
              // }              
          }

          if (from.path === '/asset-modify' && to.path === '/playlist') {
              this.current = null;
              this.updateDrawerState();

              // if(!data){
              //   this.$store.dispatch('group/updateSelectedGroupName', '플레이리스트 > All Groups');
              // }
          }

          if (to.path !== from.path) {
              // this.$store.dispatch('asset/updateFlag', false);
              // this.$store.dispatch('group/updateSelectedGroupId', 'all');
              // this.$store.dispatch('group/updateSelectedGroupName', 'All Groups');

              this.updateDrawerState();

          }
        } else {
          // console.log('처음 진입이거나 from이 없음');
        }
    }
    // updateAllGroupsName(){
    //   if(this.currentViewType === 'asset'){
    //       this.$store.dispatch('group/updateSelectedGroupName', 'VOD 관리 > All Groups');
    //   } else if(this.currentViewType === 'playlist'){
    //       this.$store.dispatch('group/updateSelectedGroupName', '플레이리스트 > All Groups');
    //   } 
    // }
  },
  created(){
    let ver = process.env.VUE_APP_VERSION ?? '1_0';
    this.Version = 'v' + ver;
  },
  mounted() {
    this.updateDrawerState();
    // this.handleRoute(this.$route, null);
  },
  computed: {
    // alllist(){
    //   return this.$store.getters.t('All Groups');
    // },
    items() {
      return this.$store.state.naviList.items;
    },
    drawerIcon() {
      return this.drawer ? 'mdi-chevron-left' : 'mdi-menu';
    },
    currentViewType() {
      if(this.current === 'asset-modify') return 'asset-modify';
      if (!this.selectedItem) return '';
      //console.log('currentViewType', this.selectedItem);
      // return this.selectedItem.to === '/playlist' ? 'playlist' : (this.selectedItem.to === '/asset' ? 'asset' : 'asset-modify');
      return this.selectedItem.to === '/playlist' ? 'playlist' : 'asset';

    },
    shouldDisplayGroupList() {
      // console.log('shouldDisplayGroupList', this.currentViewType);
      const display = this.currentViewType == 'playlist' || this.currentViewType == 'asset';
      //console.log('display', display);
      return display;
    },
  },
//   watch: {
//   '$route'(to, from) {
//     console.log('to.path:', to.path);
//     if (from && from.path) {
//       console.log('from.path:', from.path);
//     } else {
//       console.log('처음 진입이거나 from이 없음');
//     }
//   }
// }

  watch: {
     '$route': {
        handler(to, from) {
          // console.log("to => ", to)
          // console.log("from => ", from)

          if (to.path === '/asset-modify') {
              this.current = 'asset-modify';

              this.groupListDrawer = true;
              this.subMenuDrawer = false;

              this.miniState = true;
          } else if (to.path === '/asset') {
              this.groupListDrawer = true;
              this.subMenuDrawer = false;
              
              this.miniState = true;
          } else if(to.path === '/wowzastream/wowzalivestream_create'){
              this.updateDrawerState();
              this.miniState = true;

              this.groupListDrawer = false;
              this.subMenuDrawer = true;
          } else if(to.path === '/service-statistics'){
              this.updateDrawerState();
              this.miniState = true;

              this.groupListDrawer = false;
              this.subMenuDrawer = true;
          } else if(to.path === '/admin/user'){
              this.updateDrawerState();
              this.miniState = true;

              this.groupListDrawer = false;
              this.subMenuDrawer = true;
          }

          // this.handleRoute(to, from);
          if (from && from.path) {
            // console.log("to => ", to)
            // console.log("from => ", from)
            // if(to.path === '/asset-modify'){
            //   this.current = 'asset-modify';

            //   this.groupListDrawer = true;
            //   this.subMenuDrawer = false;
              
            //   this.miniState = true;
            // } else if(to.path === '/asset'){

            //   this.groupListDrawer = true;
            //   this.subMenuDrawer = false;
              
            //   this.miniState = true;
            // }

            // else if(from.path === '/playlist' && to.path === '/asset'){
            //   this.$store.dispatch('group/updateSelectedGroupId', 'all');
            //   this.$store.dispatch('group/updateSelectedGroupName', 'All Groups');
            // } 

            // else if(from.path === '/asset-modify' && to.path === '/asset'){
            //   this.current = null;
            //   this.updateDrawerState();
            // } 
            // else if(from.path === '/asset-modify' && to.path === '/playlist'){
            //   this.current = null;
            //   this.updateDrawerState();
            // }
            // else if(to.path != from.path){
            //   this.$store.dispatch('asset/updateFlag', false);
            //   this.$store.dispatch('group/updateSelectedGroupId', 'all');
            //   this.$store.dispatch('group/updateSelectedGroupName', 'All Groups');

            //   this.updateDrawerState();
            // }

            if (to.path === '/asset-modify') {
                this.current = 'asset-modify';

                this.groupListDrawer = true;
                this.subMenuDrawer = false;

                this.miniState = true;
            } else if (to.path === '/asset') {
                this.groupListDrawer = true;
                this.subMenuDrawer = false;
                
                this.miniState = true;
            } 

            if ((from.path === '/playlist' && to.path === '/asset') || (from.path === '/asset' && to.path === '/playlist')) {
                  this.$store.dispatch('group/updateSelectedGroupId', 'all');
                  this.$store.dispatch('group/updateSelectedGroupName', this.alllist);
            }

            // if ((from.path === '/playlist' && to.path === '/asset')) {
            //     this.$store.dispatch('group/updateSelectedGroupId', 'all');
            //     // this.$store.dispatch('group/updateSelectedGroupName', 'VOD 관리 > All Groups');
            //     // this.$store.dispatch('group/updateSelectedGroupName', 'All Groups');
            //     this.$store.dispatch('group/updateSelectedGroupName', 'VOD 관리 > All Groups');
            // } 

            // if ((from.path === '/asset' && to.path === '/playlist')) {
            //     this.$store.dispatch('group/updateSelectedGroupId', 'all');
            //     this.$store.dispatch('group/updateSelectedGroupName', '플레이리스트 > All Groups');
            // } 

            if ((from.path === '/playlist' && to.path !== '/asset') || from.path === '/asset' && to.path !== '/playlist') {
                this.$store.dispatch('group/updateSelectedGroupId', 'all');
                // this.$store.dispatch('group/updateSelectedGroupName', '플레이리스트 > All Groups');
                this.$store.dispatch('group/updateSelectedGroupName', this.alllist);
                // this.updateAllGroupsName();

                this.updateDrawerState();
            } 

            const data = this.$store.state.asset.watchFlag;

            if (from.path === '/asset-modify' && to.path === '/asset') {
                this.current = null;
                this.updateDrawerState();

                // if(!data){
                //   this.$store.dispatch('group/updateSelectedGroupName', 'VOD 관리 > All Groups');
                // }              
            }

            if (from.path === '/asset-modify' && to.path === '/playlist') {
                this.current = null;
                this.updateDrawerState();

                // if(!data){
                //   this.$store.dispatch('group/updateSelectedGroupName', '플레이리스트 > All Groups');
                // }
            }

            if (to.path !== from.path) {
                // this.$store.dispatch('asset/updateFlag', false);
                // this.$store.dispatch('group/updateSelectedGroupId', 'all');
                // this.$store.dispatch('group/updateSelectedGroupName', 'All Groups');

                this.updateDrawerState();

            }
          } else {
            // console.log('처음 진입이거나 from이 없음');
          }
        },
        deep: true,      
        immediate: true
    },
    // '$route'(to, from) {
    //      // console.log("to.path => ", to.path)
    //   if(to.path === '/asset-modify'){
    //     this.current = 'asset-modify'
    //     this.groupListDrawer = true;
    //     this.subMenuDrawer = false;
    //   }

    //   if(from.path === '/asset-modify' && to.path === '/asset'){
    //     this.updateDrawerState();
    //   }  
    //   else if(to.path != from.path){
    //     this.$store.dispatch('asset/updateFlag', false);
    //     this.$store.dispatch('group/updateSelectedGroupId', 'all');
    //     this.$store.dispatch('group/updateSelectedGroupName', 'All Groups');

    //     this.updateDrawerState();
    //   }


    //   // if (this.items && this.items.length > 0) {
    //   //   this.updateDrawerState();
    //   // }
    // },
    items: {
      deep: true,
      handler(newVal, oldVal) {
        //this.updateDrawerState();
        if (newVal && newVal.length > 0) {
          this.updateDrawerState();
        }
      },
    },
    drawer(newVal) {
      this.localDrawer = newVal;
    },
    localDrawer(newVal) {
      this.$emit('update:drawer', newVal);
    },
    '$store.state.lang.language': {
        handler() {
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
        immediate: true
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer_list {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.drawer-content {
  flex-grow: 1; 
  overflow-y: auto;
}

// .version {
//   padding: 8px 16px;
//   text-align: center;
//   font-size: 12px;
//   color: #888;
//   border-top: 1px solid #eee;
//   position: absolute;
//   bottom: 62px;
//   width: 100%;
// }

// .version-number {
//   margin-left: 4px;
// }

.version {
  padding: 8px 16px;
  text-align: center;
  font-size: 12px;
  color: #888;
  border-top: 1px solid #eee;
  position: absolute;
  bottom: 62px;
  width: 100%;
}

.version .version-number {
  font-weight: bold;
  color: #676767;
}

.version-label {
  margin-right: 4px;
}

.version.mini {
  justify-content: flex-end;
  padding: 8px 12px;
}

.version.mini .version-label {
  display: none; /* 필요에 따라 */
}

.version.mini .version-number {
  color: #999;
  font-size: 11px;
}

.group_list_drawer {
  margin-left: 60px !important;
  height: calc(100vh - 104px);
  z-index: 1000;
  position: fixed;
}

@media only screen and (max-width: 959px) {
  .navigation_drawer {margin-top: 56px !important; box-shadow: none !important;}
  .group_list_drawer { margin: 56px 0 0 56px !important;box-shadow: none !important; }
  .sub_menu_drawer { margin: 56px 0 0 56px !important;margin-top: 10px;box-shadow: none !important;}
}

.sub_menu_drawer {
  margin-left: 60px;
  height: calc(100vh - 64px);
  z-index: 1000;
}

.navigation_drawer {
  height: auto;
  position: fixed;
  height: calc(100vh - 64px);
  z-index: 1000;
  margin-top: 64px;
}

.mini-items .v-list-item-icon {
  min-width: 56px;
}

.v-list-item {
  align-items: center !important;
}

.mini-items .v-list-item {
  justify-content: center;
}

.flex-container {
  display: flex;
  width: 100%;
}

.mini-items {
  width: 50px;
  transition: width 0.3s ease;
}

.selected-item {
  background-color: #e0e0e0;
}

.v-overlay__scrim {
  background-color: rgba(0, 0, 0, 0.3) !important; /* 조금 더 연한 검은색 */
}
</style>
